import { render, staticRenderFns } from "./teamExerciseResult.vue?vue&type=template&id=d21093ea"
import script from "./teamExerciseResult.vue?vue&type=script&lang=js"
export * from "./teamExerciseResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports